import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { FullImageSectionEq } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface Content {
    title?: string
    text?: string
    image?: string
}

interface S3_L3_1Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_L3_1Props) => {
    const { content = {} } = props
    const { title = '', text = '', image } = content
    const heroImage = getImageData(image)

    return (
        <FullImageSectionEq
            aria-label='S3_L3_1'
            image={heroImage.src}
            height={{ xs: '45vh', md: '60vh' }}
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: 'column',
                    gap: 3,
                    width: {
                      xs: '90vw',
                      md: '60vw',
                      lg: '40vw',
                    },
                  }}
            >
                <Typography
                    variant='h1'
                    color='white'
                >
                    {title}
                </Typography>
                <Typography
                    variant='body2'
                    color='white'
                >
                    {text}
                </Typography>
            </Box>
        </FullImageSectionEq>
    )
}

export default Index
